module.exports = __webpack_public_path__ + "static/media/article3.ed99ade4.png";